import isString from 'lodash/isString';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstLetter',
    standalone: false
})
export class FirstLetterPipe implements PipeTransform {
  transform(value: string): string {
    if (isString(value)) {
      return value.charAt(0);
    }

    return null;
  }
}
